module.exports = __webpack_public_path__ + "img/bol.com.9c5c37e.png";